import { actionTypes } from '../../../types';

export const deactivateAccountRequest = (payload, callback) => ({
    type: actionTypes.DEACTIVATE_ACCOUNT_REQUEST,
    payload,
    callback,
});

export const deactivateAccountSuccess = (payload) => ({
    type: actionTypes.DEACTIVATE_ACCOUNT_SUCCESS,
    payload,
});

export const deactivateAccountFailure = (payload) => ({
    type: actionTypes.DEACTIVATE_ACCOUNT_FAILURE,
    payload,
});

export const deactivateAccountReset = () => ({
    type: actionTypes.DEACTIVATE_ACCOUNT_RESET,
});
